import { SignalFilled } from '@compass/Icon'
import { QueryFilterOption } from 'components/QueryFilters'

import {
  BOT_CATEGORY_ICONS,
  BOT_CATEGORY_LABELS,
  BOT_CONFIDENCE_LABELS,
  BOT_CONFIDENCE_SEVERITY,
  BOT_IDENTITY_COLORS,
  BOT_IDENTITY_ICONS,
  BOT_IDENTITY_LABELS,
  getAIBotLogo,
  getBotProviderLabel,
  getBotProviderLogo,
} from './consts'
import { BotCategory, BotConfidence, BotIdentity } from './models'

const BOT_CATEGORY_VALUES = Object.keys(BOT_CATEGORY_LABELS) as BotCategory[]
const BOT_IDENTITY_VALUES = Object.keys(BOT_IDENTITY_LABELS) as BotIdentity[]
const BOT_CONFIDENCE_VALUES = Object.keys(BOT_CONFIDENCE_LABELS) as BotConfidence[]

export const categoryOptions = BOT_CATEGORY_VALUES.map((value) => {
  const Icon = BOT_CATEGORY_ICONS[value]

  return {
    id: value,
    name: BOT_CATEGORY_LABELS[value],
    icon: <Icon size={16} />,
  }
})

export const identityOptions = BOT_IDENTITY_VALUES.map((value) => {
  const Icon = BOT_IDENTITY_ICONS[value]

  return {
    id: value,
    name: BOT_IDENTITY_LABELS[value],
    icon: <Icon size={16} stroke={BOT_IDENTITY_COLORS[value].icon} />,
  }
})

export const confidenceOptions = BOT_CONFIDENCE_VALUES.map((value) => {
  const { bars, color } = BOT_CONFIDENCE_SEVERITY[value]

  return {
    id: value,
    name: BOT_CONFIDENCE_LABELS[value],
    icon: <SignalFilled filledBars={bars} size={16} fill={color} />,
  }
})

export function uniqueOptions(values: string[]): QueryFilterOption[] {
  return [...new Set(values.filter(Boolean))].sort().map((value) => ({ id: value, name: value }))
}

export function withProviderLabelsAndIcons(options: QueryFilterOption[]): QueryFilterOption[] {
  return options.map((option) => {
    const Logo = getBotProviderLogo(option.id)

    return {
      ...option,
      name: getBotProviderLabel(option.id),
      icon: <Logo size={16} />,
    }
  })
}

export function withBotNameIcons(options: QueryFilterOption[]): QueryFilterOption[] {
  return options.map((option) => {
    const Logo = getAIBotLogo({ name: option.id })
    return { ...option, icon: <Logo size={16} /> }
  })
}

export function mergeSelectedOptions(options: QueryFilterOption[], selectedValues?: string[]) {
  const optionIds = new Set(options.map((option) => option.id))
  const selectedOptions = (selectedValues ?? [])
    .filter((value) => !optionIds.has(value))
    .map((value) => ({ id: value, name: value }))

  return [...options, ...selectedOptions]
}

export function mergeRememberedOptions(previousOptions: QueryFilterOption[], nextOptions: QueryFilterOption[]) {
  const optionsById = new Map(previousOptions.map((option) => [option.id, option]))

  nextOptions.forEach((option) => {
    optionsById.set(option.id, option)
  })

  return [...optionsById.values()].sort((left, right) => left.name.localeCompare(right.name))
}
